import * as React from 'react';
export const dragElement = (elmnt, header) => {
  if (!elmnt) { 
    return;
  }

  let startX = 0, startY = 0;
  let moveX = 0, moveY = 0

  if (header) {
    /* if present, the header is where you move the DIV from:*/
    header.onpointerdown = dragMouseDown;
  } else {
    /* otherwise, move the DIV from anywhere inside the DIV:*/
    elmnt.onpointerdown = dragMouseDown;
  }

  function dragMouseDown(e) {
    e = e || window.event;    

    const rect = e.currentTarget.getBoundingClientRect();
    if (e.clientY - rect.y > 30) return;

    e.preventDefault();
    // get the mouse cursor position at startup:
    startX = e.clientX;
    startY = e.clientY;    
    document.onpointerup = closeDragElement;
    // call a function whenever the cursor moves:
    document.onpointermove = elementDrag;
  }

  function elementDrag(e) {
    e = e || window.event;
    e.preventDefault();
    // calculate the new cursor position:
    moveX = e.clientX - startX;
    moveY = e.clientY - startY;
    startX = e.clientX;
    startY = e.clientY;
    // set the element's new position:
    elmnt.style.top = (elmnt.offsetTop + moveY) + "px";
    elmnt.style.left = (elmnt.offsetLeft + moveX) + "px";
    //console.log('... dragElement .Down.', e)
  }

  function closeDragElement() {
    /* stop moving when mouse button is released:*/
    document.onpointerup = null;
    document.onpointermove = null;
  }
}

export function setTranslate(elmnt, tx, ty) {
  if (!elmnt) return;
  tx = tx || 0;
  ty = ty || 0;
  const style = getComputedStyle(elmnt);
  const matrix = new DOMMatrixReadOnly(style.transform)  
  elmnt.style.transform = `translate(${matrix.m41 + tx}px, ${matrix.m42 + ty}px)`  
}

const dragElementTranslate = (elmnt, header) => {
  if (!elmnt) { 
    return;
  }

  let startX = 0, startY = 0;

  if (header) {
    /* if present, the header is where you move the DIV from:*/
    header.onpointerdown = dragMouseDown;
    header.style.cursor = 'move';
  } else {
    /* otherwise, move the DIV from anywhere inside the DIV:*/
    elmnt.onpointerdown = dragMouseDown;    
    elmnt.style.cursor = 'move';
  }

  function dragMouseDown(e) {
    e = e || window.event;

    if (!header) {
      const rect = e.currentTarget.getBoundingClientRect();
      if (e.clientY - rect.y > 30) return;
    }
        
    e.preventDefault();
    // get the mouse cursor position at startup:
    startX = e.clientX;
    startY = e.clientY;    
    document.onpointerup = closeDragElement;
    // call a function whenever the cursor moves:
    document.onpointermove = elementDrag;
  }

  function elementDrag(e) {
    e = e || window.event;
    e.preventDefault();
    setTranslate(elmnt, e.clientX - startX, e.clientY - startY)
    startX = e.clientX;
    startY = e.clientY;    
  }

  function closeDragElement() {
    /* stop moving when mouse button is released:*/
    document.onpointerup = null;
    document.onpointermove = null;
  }
}

export const Bs4Draggable = React.forwardRef((props, ref) => {  
    
  React.useEffect(() => {
    ref = props.refElement;
    dragElementTranslate(props.refElement?.current, props.refHeader?.current);
  }, [props.refElement?.current, props.refHeader?.current, props.children] )

  return props.children
});

export default Bs4Draggable;